export default "__VITE_ASSET__5537313b__"